import React from 'react';

import Icon from '../Icon';

const AiAssistantCloseCircleIcon = (props) => {
    return (
        <Icon width='32' height='32' viewBox='0 0 32 32' fill='none' {...props}>
            <rect width='32' height='32' rx='16' fill='#393E44' />
            <path d='M21.5892 10.7116L10.7117 21.5891' stroke='#FFFDFB' strokeWidth='1.09091' strokeLinecap='round' />
            <path d='M10.7116 10.7116L21.5891 21.5891' stroke='#FFFDFB' strokeWidth='1.09091' strokeLinecap='round' />
        </Icon>
    );
};

export default AiAssistantCloseCircleIcon;
